// extracted by mini-css-extract-plugin
export default {"textButton":"_2LHGtMfaDmaPbCz3VIfyak"};